<template>
  <sui-page>
    <sui-page-header :pageId="$options.name" />
    <sui-page-contents>
      <div class="comm_view_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_EMPL_NM')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <cmp-emp-select
              v-if="false === isKnowUserDisable"
              :selectedKnoxUser="selectedKnoxUser"
              :checkboxMode="false"
              :fixedIcon="true"
              :disabled="knoxUserDisable"
              @selected="onSelectedKnox"
            />
            <div
              v-else
              class="comm_label"
            >
              <sui-input-label
                :label="targetUserData.usrNm"
                :vertical="false"
              />
            </div>
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_DEPT_NM')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <div class="comm_label">
              {{ targetUserData.deptNm }}
            </div>
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_CPNY_NM')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <div class="comm_label">
              {{ targetUserData.cpnyNm }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_LANG')"
              :vertical="false"
              required
            />
          </div>
          <div class="col-xs-3">
            <sui-lang-select
              ref="selectLNG"
              :selected="selectedCode.LNG"
              :pageId="$options.name"
              codeId="COD_PAGE_UE"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_TZONE_AREA')"
              :vertical="false"
              required
            />
          </div>
          <div class="col-xs-3">
            <sui-code-select
              ref="selectDIV"
              :selected="selectedCode.DIV"
              :pageId="$options.name"
              codeId="COD_TZONE_DIV"
              @loaded="timezoneLoaded"
              @list-clicked="onTimezoneSelect"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_TZONE_GMT')"
              :vertical="false"
              required
            />
          </div>
          <div class="col-xs-3">
            <sui-custom-select
              ref="selectTMZ"
              :selected="selectedCode.TMZ"
              :optionList="timezoneGMTList"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_DISP_LNG')"
              :vertical="false"
              required
            />
          </div>
          <div class="col-xs-3">
            <sui-lang-select
              ref="selectDPL"
              :selected="selectedCode.DPL"
              :pageId="$options.name"
              codeId="COD_PAGE_UE"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_NUM_FMT')"
              :vertical="false"
              required
            />
          </div>
          <div class="col-xs-3">
            <sui-code-select
              ref="selectNFM"
              :selected="selectedCode.NFM"
              :pageId="$options.name"
              codeId="COD_DGR_TYPE"
            />
          </div>

          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_DT_DISP')"
              :required="false"
            />
          </div>
          <div class="col-xs-3">
            <div class="comm_label">
              {{ todayDateFormat}}
            </div>
          </div>
          <!-- <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_LOW_SPEC_YN')"
              :required="true"
            />
          </div>
          <div class="col-xs-7">
            <sui-radio
              v-model="selectedCode.LSP.key"
              value="Y"
            >
              Yes
            </sui-radio>
            <sui-radio
              v-model="selectedCode.LSP.key"
              value="N"
            >
              No
            </sui-radio>
          </div> -->
        </div>
        <div class="row" v-if="this.$route.query.status === 'MOD'">  
          <div
            v-if="this.$route.query.status === 'MOD'"
            class="col-xs-1"
          >
            <sui-input-label
              :label="$t('MSG_TXT_ACC_USE_YN')"
              :vertical="false"
            />
          </div>
          <div
            class="col-xs-3"
          >
            <div class="comm_label">
              {{ targetUserData.accountUseYn }}
            </div>
          </div>
          <div
            class="col-xs-1"
          >
            <sui-input-label
              :label="$t('MSG_TXT_ACC_STATUS')"
              :vertical="false"
              required
            />
          </div>
          <div
            class="col-xs-3"
          >
            <sui-code-select
              ref="selectACO"
              :selected="selectedCode.ACO"
              :pageId="$options.name"
              codeId="COD_USR_ACO_STT"
              :disabled="disabled"
              :defaultOption="'select'"
              :initialSelectedIndex="0"
            />
          </div>
          <div
            class="col-xs-1 nodata"
          />
          <div
            class="col-xs-3"
          />
        </div>
      </div>
      <div class="mrB30" />

      <div class="comm_title_wrap">
        <h4 class="comm_tit02">
          {{ $t('MSG_TXT_PSS_AUTH_LIST') }}
        </h4>
      </div>
      <sui-grid
        ref="grdPssAuth"
        :showCountControl="true"
        :showDisplayCountControl="false"
        :pageable="false"
        :sortable="false"
        :filterable="false"
        :columns="gridColumns0"
        :dataset="'dsPassAuth'"
        :rowMovable="false"
        :multiselect="false"
      >
        <div class="comp_spacing" />
        <div class="btn_wrapL">
          <sui-button
            v-permission:update="'PGE_CMY_00023'"
            type="button"
            class="comm_btn_gridTop"
            @click="onAddItem"
          >
            {{ $t('MSG_BTN_ADD') }}
          </sui-button>
          <sui-button
            v-permission:delete="'PGE_CMY_00023'"
            type="button"
            class="comm_btn_gridTop"
            @click="onDeleteItem"
          >
            {{ $t('MSG_BTN_DEL') }}
          </sui-button>
        </div>
      </sui-grid>

      <!--
        <div class="inbox">
          <div class="comm_title_wrap">
            <h4 class="comm_tit02">
              {{ $t('MSG_TXT_AUTH_ADD') }}
            </h4>
          </div>
          <sui-grid
            ref="grdAuthAdd"
            :columns="gridColumns1"
            :showCountControl="true"
            :showDisplayCountControl="false"
            :sortable="false"
            :filterable="false"
            :dataset="'dsAuthAdd'"
            :multiselect="true"
          >
            <div class="btn_wrapL mrL30">
              <sui-button
                v-permission:update="'PGE_CMY_00023'"
                type="button"
                class="comm_btn_gridTop"
                @click="onAddItem"
              >
                {{ $t('MSG_BTN_ADD') }}
              </sui-button>
              <sui-button
                v-permission:delete="'PGE_CMY_00023'"
                type="button"
                class="comm_btn_gridTop"
                @click="onDeleteItem"
              >
                {{ $t('MSG_BTN_DEL') }}
              </sui-button>
            </div>
          </sui-grid>
        </div>-->

      <div class="mrB30" />
      <div class="comm_btnBot_wrap">
        <div class="btn_wrapL">
          <sui-button
            type="button"
            class="comm_btn_border"
            @click="onClose"
          >
            {{ $t('MSG_BTN_LIST') }}
          </sui-button>
        </div>
        <div class="btn_wrapR">
          <sui-button
            v-permission:create="'PGE_CMY_00023'"
            type="button"
            class="comm_btn_solid"
            @click="onSave"
          >
            {{ $t('MSG_BTN_SAVE') }}
          </sui-button>
        </div>
      </div>
    </sui-page-contents>
    <sui-popup
      v-model="showRightPopup"
      :title="$t('MSG_TIT_USER_GROUP_SRCH')"
    >
      <rightAddPopup
        :parentPageId="$options.name"
        @save="onPopupSaveClicked"
        @cancel="onPopupCancelClicked"
      />
    </sui-popup>
  </sui-page>
</template>
<script>
import rightAddPopup from './components/PGE_CMY_00023_P01';

export default {
  name: 'PGE_CMY_00023', // eslint-disable-line vue/name-property-casing
  components: {
    rightAddPopup,
  },
  data() {
    return {
      applyAuthorityYn: 'N',
      disabled: false,
      paramData: {},
      knoxUserDisable: false,
      targetUserData: {},
      isExistPerson: 0,
      showRightPopup: false,
      sessionInfo: {},
      selectedKnoxUser: {
        knoxId: '',
        userName: '',
        epId: '',
        epNo: '',
        email: '',
        cpnyCd: '',
        cpnyNm: '',
        deptId: '',
        deptNm: '',
        deptEnNm: '',
        usrGlblNm: '',
        crlvCd: '',
      },
      selectedCode: {
        SIT: { key: '', label: '' },
        GBM: { key: '', label: '' },
        NFM: { key: '', label: '' },
        LNG: { key: '', label: '' },
        DIV: { key: '', label: '' },
        TMZ: { key: '', label: '' },
        DPL: { key: '', label: '' },
        ACO: { key: '', label: '' },
        LSP: { key: 'N', label: '' },
      },
      timezoneGMTList: [],
      localdata1: [],
      gridColumns0: [
        {
          text: '',
          datafield: 'check',
          align: 'center',
          width: '40',
          createwidget: (row, column, value, htmlElement) => {
            utils.getGridCellFactory().createCellCheckbox(row, column, value, htmlElement, {
            }, this.dsPassAuth, this.$refs.grdPssAuth);
          },
          initwidget(row, column, value, htmlElement) {
            utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
          },
        },
        {
          text: this.$t('MSG_TXT_TASK_TYPE'),
          datafield: 'taskName',
        }, {
          text: this.$t('MSG_TXT_USER_GRP_NAME'),
          datafield: 'userGroupName',
          createwidget: (row, column, value, htmlElement) => {
            utils.getGridCellFactory().createCellButton(row, column, value, htmlElement, {
              handler: this.onSelectUserGroup,
              type: 'link',
            }, this.dsPassAuth, this.$refs.grdPssAuth);
          },
          initwidget(row, column, value, htmlElement) {
            utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
          },
        }, {
          text: this.$t('MSG_TXT_AUTH_APPR_STT'),
          datafield: 'authRequestStatusName',
        },
        {
          text: this.$t('MSG_TXT_VALID_PERIOD'),
          datafield: 'validFinishDT',
          width: 150,
          createwidget: (r, c, v, h) => utils.getGridCellFactory().createCellDateLabel(r, c, v, h, { formatOption: 'S' }, this.dsPassAuth, this.$refs.grdPssAuth),
          initwidget: (r, c, v, h) => utils.getGridCellFactory().refreshCell(r, c, v, h),          
        }],
      todayDateFormat : '',
    };
  },
  computed: {
    isKnowUserDisable() {
      return this.knoxUserDisable;
    },
  },
  watch: {},
  datasets: [{
    id: 'dsPassAuth',
    type: 'local',
    data: 'localdata1',
    datafields: [
      { name: 'check', type: 'string', map: 'check' },
      { name: 'taskId', type: 'string', map: 'taskId' },
      { name: 'taskName', type: 'string', map: 'taskName' },
      { name: 'userGroupId', type: 'string', map: 'userGroupId' },
      { name: 'userGroupName', type: 'string', map: 'userGroupName' },
      { name: 'authRequestStatusCode', type: 'string', map: 'authRequestStatusCode' },
      { name: 'authRequestStatusName', type: 'string', map: 'authRequestStatusName' },
      { name: 'validFinishDT', type: 'string', map: 'validFinishDT' },
    ],
  },
  ],
  mounted() {
    this.$nextTick(() => {
      this.load();
    });
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    onSelectedKnox() {
      if (this.selectedKnoxUser !== 'undefined'
          && this.selectedKnoxUser !== ''
          && this.selectedKnoxUser !== null) {
        let deptName = '';

        const langId = utils.isEmpty(this.$store.getters.userInfo.userPersonalizationLang) === true
          ? 'en' : this.$store.getters.userInfo.userPersonalizationLang;

        if (utils.isEqual(langId, 'en') === true) {
          deptName = utils.trim(this.selectedKnoxUser.deptEnNm);
        } else {
          deptName = utils.trim(this.selectedKnoxUser.deptNm);
        }

        const tempData = {
          knoxId: utils.trim(this.selectedKnoxUser.knoxId) || '',
          userId: utils.trim(this.selectedKnoxUser.epId) || '',
          epid: utils.trim(this.selectedKnoxUser.epId) || '',
          usrNm: utils.trim(this.selectedKnoxUser.userName) || '',
          usrGlblNm: utils.trim(this.selectedKnoxUser.usrGlblNm) || '',
          cpnyCd: utils.trim(this.selectedKnoxUser.cpnyCd) || '',
          cpnyNm: utils.trim(this.selectedKnoxUser.cpnyNm) || '',
          deptId: utils.trim(this.selectedKnoxUser.deptId) || '',
          deptNm: deptName || '',
          crlvCd: utils.trim(this.selectedKnoxUser.crlvCd) || '',
        };

        if (utils.isEmpty(tempData.knoxId) === false) {
          this.targetUserData = tempData;
          this.personalizationLoad(this.targetUserData.epid);
          this.retentionInfo(this.targetUserData.epid);
        }
      }
    },
    timezoneLoaded(list) {
      const [first] = list;
      this.timezoneGMTListLoad(first.key);
    },
    onTimezoneSelect() {
      const code = this.selectedCode.DIV.key;
      this.timezoneGMTList = [];
      this.selectedCode.TMZ.key = '';
      this.timezoneGMTListLoad(code);
    },
    onAddItem() {
      this.showRightPopup = true;
    },
    onDeleteItem() {
      if (this.dsPassAuth != null) {
        const selectedIndexes = []; // this.dsPassAuth.getSelectedIndexes();
        let idx = 0;
        utils.forEach(this.dsPassAuth.data, obj => {
          if (utils.isEqual(obj.check, 'Y')) {
            selectedIndexes.push(idx);
          }
          idx++;
        });
        this.dsPassAuth.deleteRows(selectedIndexes);
      }
    },
    onClose() {
      // utils.goPage('PGE_CMY_00009', { userData: this.targetUserData });
      utils.goPage('PGE_CMY_00009', { paramData: this.paramData });
    },
    onSave() {
      const saveList = [];
      const userId = this.targetUserData.epid;
      let isBlank = false;
      let dataKey = '';

      if (utils.isEmpty(userId) === true) {
        utils.messageBox('error', this.$t('MSG_ALT_USER_SEL'));
        return;
      }

      utils.forEach(this.selectedCode, (value, key) => {
        if (utils.isEmpty(value.key) === true || value.key === ' ') {
          if (this.$route.query.status === 'ADD' && key !== 'ACO') {
            isBlank = true;
            dataKey = key;
          }
        } else if (!utils.isEqual(key, 'DIV')) {
          saveList.push({
            userId,
            personalizationTypeCode: key,
            personalizationValue: value.key,
          });
        }
      });

      if (isBlank === true) {
        const labelName = this.getLabelName(dataKey);
        const msg = utils.strFormat(this.$t('MSG_ALT_NCELL_REQUIRED_VAL'), labelName);
        utils.messageBox('error', msg);
        return;
      }

      // 권한 신청 부분
      const dsData = [];

      // 중복신청 체크
      const unique = [];
      const duplicates = this.dsPassAuth.data.filter(item => {
        if (unique.find(i => i.userGroupId === item.userGroupId)) {
          return true;
        }
        unique.push(item);
        return false;
      });
      if (duplicates.length > 0) {
        utils.messageBox('warning', this.$t('MSG_ALT_DUPLICATE_EXISTS'));
        return;
      }

      utils.forEach(this.dsPassAuth.data, item => {
        if (item.authRequestStatusCode !== 'S') {
          dsData.push(
            {
              userGroupId: utils.trim(item.userGroupId),
              taskId: utils.trim(item.taskId),
              validFinishDT: utils.trim(item.validFinishDT),
              userId,
              deleteYn: 'N',
            },
          );
        }
      });

      const paramList = {
        epId: userId,
        existPerson: this.isExistPerson,
        // sonarcode codesmell 대응
        // userGrpList: dsData || '',
        // personalizationList: saveList || '',
        userGrpList: dsData,
        personalizationList: saveList,
      };
      utils.messageBox('confirm', this.$t('MSG_ALT_WANT_SAVE'), null, () => {
        http.request(this.$options.name, 'DTS_CMY_00035', {
          data: paramList,
        }).then(() => {
          utils.messageBox('success', this.$t('MSG_ALT_SAVE_DATA'));

          // 저장 후 gird rowState 초기화
          // this.dsAuthAdd.submit();
          this.retentionInfo(userId);
        }).catch(error => {
          console.log(error);
        });
      });
    },
    onPopupSaveClicked(dsData) {
      if (dsData.length > 0) {
        utils.forEach(dsData, data => {
          data.validFinishDT = '99991231';
          data.isNewData = true;
          data.check = 'N';
        });
        this.dsPassAuth.addRows(dsData);
      }

      this.showRightPopup = false;
    },
    onPopupCancelClicked() {
      this.showRightPopup = false;
    },
    getSession() {
      this.sessionInfo = this.$store.getters.userInfo;
    },
    load() {
      const { status } = this.$route.query;
      if (utils.isEmpty(status) === false) {
        if (utils.isEqual(status, 'ADD') === true) {
          this.paramData = this.$route.query.paramData;
          this.targetUserData = {};
          this.knoxUserDisable = false;
        } else {
          this.paramData = this.$route.query.paramData;
          this.targetUserData = this.$route.query.userData;
          this.knoxUserDisable = true;
          // 계정보유여부가 No인 경우 계정상태 비활성화
          if (this.targetUserData.accountUseYn === 'No') {
            this.disabled = true;
          }
        }
      }
      if (typeof this.paramData === 'object' && typeof this.targetUserData === 'object') {
        this.getSession();
        if (this.knoxUserDisable === true) {
          if (this.targetUserData) {
            this.personalizationLoad(this.targetUserData.epid);
            this.retentionInfo(this.targetUserData.epid);
          }
        }        
      } else {
        utils.goPage('PGE_CMY_00009');
      }
    },
    personalizationLoad(userId) {
      http.request(this.$options.name, 'DTS_CMP_00001', {
        path: {
          'user-id': userId,
        },
      }).then(res => {
        if (res.data.length > 1) {
          this.isExistPerson = 1;
          utils.forEach(res.data, value => {
            if (value.personalizationTypeCode === 'ACO' && this.targetUserData.accountUseYn === 'No') {
              this.selectedCode[value.personalizationTypeCode] = { key: ' ' };
            } else {
              this.selectedCode[value.personalizationTypeCode] = { key: value.personalizationValue };
            }
            if (utils.isEqual(value.personalizationTypeCode, 'TMZ')) {
              this.selectedCode.DIV = { key: value.timezoneDivCode };
              this.timezoneGMTListLoad(value.timezoneDivCode);
            }
          });
        } else {
          const value = res.data[0];
          // if (value.personalizationValue) {
          if (value !== undefined) {
            // 개인화 정보는 없지만 UserMaster 정보는 있는경우
            this.isExistPerson = 1;
            this.selectedCode[value.personalizationTypeCode] = { key: value.personalizationValue };
          } else {
            // UserMaster도 없는 완전 신규 유저
            this.isExistPerson = 0;

            // 기본값을 세션값으로 지정
            this.selectedCode.DIV.key = 'ASI';
            this.selectedCode.TMZ.key = this.sessionInfo.timezoneId;
            this.selectedCode.LNG.key = this.sessionInfo.langId;
            this.selectedCode.DPL.key = this.sessionInfo.langId;

            if (!utils.isEmpty(this.selectedCode.DIV.key)) {
              this.timezoneGMTListLoad(this.selectedCode.DIV.key);
            }
          }
        }
        this.todayDateFormat = utils.now(this.sessionInfo.dateFormat);
      }).catch(error => {
        console.log(error);
      });
    },
    timezoneGMTListLoad(timezoneDivCode) {
      http.request(this.$options.name, 'DTS_CMZ_00078', {
        path: {
          'timezone-div-code': timezoneDivCode,
        },
      }).then(res => {
        const timezoneList = [];
        utils.forEach(res.data, timezone => {
          timezoneList.push({
            key: timezone.timezoneId,
            label: timezone.timezoneName,
          });
        });
        this.timezoneGMTList = timezoneList;
      }).catch(error => {
        console.log(error);
      });
    },
    retentionInfo(epid) {
      http.request(this.$options.name, 'DTS_CMA_00026', {
        path: {
          'user-id': epid || '',
        },
      }).then(res => {
        if (res.data.length > 0) {
          const passAuth = [];
          const addAuth = [];
          utils.forEach(res.data, item => {
            passAuth.push({
              check: item.authRequestStatusCode === 'S' ? 'O' : 'N',
              taskId: item.taskId,
              taskName: item.taskName,
              userGroupId: item.userGroupId,
              userGroupName: item.userGroupName,
              authRequestStatusCode: item.authRequestStatusCode,
              authRequestStatusName: item.authRequestStatusName,
              validFinishDT: item.validFinishDT,
            });
          });

          this.dsPassAuth.setRawData(passAuth);
          // this.dsAuthAdd.setRawData(addAuth);
        } else {
          this.dsPassAuth.setRawData([]);
          // this.dsAuthAdd.setRawData([]);
        }
      }).catch(error => {
        console.log(error);
      });
    },
    getLabelName(labelName) {
      let resultData = '';
      switch (labelName) {
        case 'NFM':
          resultData = this.$t('MSG_TXT_NUM_FMT');
          break;
        case 'LNG':
          resultData = this.$t('MSG_TXT_LANG');
          break;
        case 'DIV':
          resultData = this.$t('MSG_TXT_TZONE_AREA');
          break;
        case 'TMZ':
          resultData = this.$t('MSG_TXT_TZONE_GMT');
          break;
        case 'DPL':
          resultData = this.$t('MSG_TXT_DISP_LNG');
          break;
        case 'ACO':
          if (this.targetUserData.accountUseYn === 'Yes') {
            resultData = this.$t('MSG_TXT_ACC_STATUS');
          }
          break;
        default:
          // do nothing
          break;
      }
      return resultData;
    },
    onSelectUserGroup(btn, dataRow) {
      utils.openLayerPopup('PGE_CMA_00015', this.onPagePopupCallback, {
        pageInitialData: {
          userGroupId: dataRow.userGroupId,
        },
        size: 'lg',
      });
    },
  },
};
</script>
<style scoped>
</style>
